import CreateAndEditMultipleItemsModal from './CreateAndEditMultipleItemsModal.container'
export default CreateAndEditMultipleItemsModal
